import React, { useRef, useMemo, useCallback } from 'react';
import styled from 'styled-components/macro';

import useMediaStore from '../../../../../common/store/useMediaStore';
import Container from '../../Container';
import { getVh } from '../../utils';
import useParallax from '../../useParallax';
import useAnimation from './useAnimation';
import useFlavorStore from '../../../../../common/store/useFlavorStore';

const Uno = styled.img`
  aspect-ratio: 256/362;
  width: 100rem;
  height: auto;
`;

const Dos = styled.img`
  aspect-ratio: 153/238;
  width: 190rem;
  height: auto;

  transform: rotate(10deg);
`;

const Leaf = styled.img`
  aspect-ratio: 215/134;
  width: 120rem;
  height: auto;
`;

const Pear = () => {
  /**
   * Hooks
   */
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));
  const md = useMediaStore(useCallback(state => state.md, []));

  const ref = {
    figure: {
      uno: useRef<HTMLElement>(null),
      dos: useRef<HTMLElement>(null),
      leaf: useRef<HTMLElement>(null)
    },
    img: {
      uno: useRef<HTMLImageElement>(null),
      dos: useRef<HTMLImageElement>(null),
      leaf: useRef<HTMLImageElement>(null)
    }
  }

  const top = {
    uno: useMemo(() => getVh("flavor", 0.7), []),
    dos: useMemo(() => getVh("flavor", 0.4), []),
    leaf: useMemo(() => getVh("flavor", 0.3), [])
  }

  useAnimation(flavor === "pear", [ref.figure.uno, ref.figure.dos, ref.figure.leaf]);

  useParallax(ref.img.uno, top.uno, 100);
  useParallax(ref.img.dos, top.dos, 100);
  useParallax(ref.img.leaf, top.leaf, 100);

  /**
   * Not hook
   */
  const dosStyle = !md ?
    { left: "60vw" } :
    { right: "8vw" }


  /**
   * Render
   */
  return (
    <>
      <Container
        ref={ref.figure.uno}
        top={top.uno}
        style={{ left: "60vw" }}
      >
        <Uno
          ref={ref.img.uno}
          src="/static/images/fill/pear/1.png" />
      </Container>

      <Container
        ref={ref.figure.dos}
        top={top.dos}
        style={dosStyle}
      >
        <Dos
          ref={ref.img.dos}
          src="/static/images/fill/pear/2.png"
        />
      </Container>

      <Container
        ref={ref.figure.leaf}
        top={top.leaf}
        style={{ left: "65vw" }}
      >
        <Leaf
          ref={ref.img.leaf}
          src="/static/images/fill/rosemary/1.png"
        />
      </Container>
    </>
  );
}

export default Pear;